// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface MetaConfigOut {}

export const MetaConfigOutSerializer = {
  _fromJsonObject(_object: any): MetaConfigOut {
    return {};
  },

  _toJsonObject(_self: MetaConfigOut): any {
    return {};
  },
};
